module.exports = __webpack_public_path__ + "static/media/product_use_case_2.a6d508b3.svg";